import { render } from "./ApplicationApproval.vue?vue&type=template&id=087c1ed8"
import script from "./ApplicationApproval.vue?vue&type=script&lang=js"
export * from "./ApplicationApproval.vue?vue&type=script&lang=js"

import "./ApplicationApproval.vue?vue&type=style&index=0&id=087c1ed8&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__